import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Home.css';
import { FaCode, FaMobile, FaPaintBrush, FaChartLine ,FaServer,FaCloudUploadAlt,FaSearch} from 'react-icons/fa';

// ← ضع مسار صورتك هنا
// import myPhoto from '../assets/images/me.jpg';
// أو إذا كانت في مجلد public:
const myPhoto = '/images/me.png';

const PortfolioAR = () => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const [activeSection, setActiveSection] = useState(null);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLatestProjects = async () => {
      try {
        const response = await fetch('https://my-portfoli-backed.onrender.com/api/projects/latest', {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          mode: 'cors'
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();
        setProjects(data.data.projects);
      } catch (err) {
        console.error('Error fetching projects:', err);
        setError('حدث خطأ في جلب المشاريع');
      } finally {
        setLoading(false);
      }
    };
    fetchLatestProjects();
  }, []);

  const services = [
  { id: 2, title: "تطبيقات الموبايل", description: "تصميم وتطوير تطبيقات الهاتف", icon: <FaMobile size={24} /> },

  { id: 1, title: "تطوير الويب", description: "بناء مواقع وتطبيقات ويب باستخدام أحدث التقنيات", icon: <FaCode size={24} /> },

  { id: 4, title: "تصميم الواجهات", description: "تصميم واجهات مستخدم جذابة وسهلة الاستخدام", icon: <FaPaintBrush size={24} /> },

  { id: 6, title: "تحليل البيانات", description: "تحليل بيانات الزوار واتخاذ القرارات المبنية على البيانات", icon: <FaChartLine size={24} /> },

  // 🔥 الخدمات الجديدة
  { id: 7, title: "إدارة السيرفرات", description: "إعداد وإدارة السيرفرات ورفع المشاريع وضمان استقرارها وأمانها", icon: <FaServer size={24} /> },

  { id: 8, title: "رفع ونشر المواقع", description: "نشر المواقع على الإنترنت وربطها بالدومين بشكل احترافي وسريع", icon: <FaCloudUploadAlt size={24} /> },

  { id: 9, title: "تحسين محركات البحث (SEO)", description: "تحسين ظهور موقعك في نتائج البحث وزيادة عدد الزوار", icon: <FaSearch size={24} /> }
];

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('ar-EG', options);
  };

  return (
    <div className="portfolio-container-ar">

      {/* ===== قسم البداية ===== */}
      <section className="hero-section-ar">
        <div className="hero-content-ar">

          {/* الصورة + الاسم والبادج في صف */}
          {/* <div className="hero-top-row-ar">
      <div className="hero-avatar-wrapper-ar">
        <img src={myPhoto} alt="عبدالرحمن" className="hero-avatar-ar" />
        <span className="hero-avatar-online-ar" title="متاح للعمل" />
      </div>
      <div className="hero-profile-info-ar">
        <span className="hero-profile-name-ar">عبدالرحمن</span>
        <span className="hero-profile-badge-ar">Full-Stack Developer</span>
      </div>
    </div> */}

          <div className="hero-divider-ar" />

          {/* العنوان والوصف والأزرار */}
          <div className="hero-main-ar">
            <span className="hero-eyebrow-ar">مطور تطبيقات ومواقع ويب</span>
            <h1 className="hero-title-ar">
              أبني تجارب رقمية <span>استثنائية</span>
            </h1>
            <p className="hero-description-ar">
              أصمم وأطور تطبيقات ومواقع ويب ببرمجة نظيفة وفعّالة،
              وواجهات مستخدم مدروسة تركّز على الأداء وتجربة المستخدم.
            </p>
            <div className="hero-actions-ar">
              <Link to="/projects" className="primary-button-ar">عرض أعمالي</Link>
              <Link to="/contact" className="secondary-button-ar">تواصل معي</Link>
            </div>
          </div>

          <div className="hero-divider-ar" />

          {/* الإحصائيات + التقنيات */}
          <div className="hero-bottom-ar">
            <div className="stats-row-ar">
              <div className="stat-item-ar">
                <span>+2</span>
                <small>سنوات خبرة</small>
              </div>
              <div className="stat-item-ar">
                <span>+5</span>
                <small>مشروع منجز</small>
              </div>
              <div className="stat-item-ar">
                <span>Full-Stack</span>
                <small>التخصص</small>
              </div>
            </div>
            <div className="tech-stack-ar">
              <span>MERN</span>
              <span>FLUTTER</span>
              {/* <span>MongoDB</span> */}
            </div>
          </div>
          <div className="about-more-ar">
            <Link to="/about" className="more-button-ar">عرض المزيد عني →</Link>
          </div>
        </div>
      </section>

      {/* ===== قسم عني ===== */}
      {/* <section
        className={`about-section-ar ${activeSection === 'about' ? 'active' : ''}`}
        onMouseEnter={() => setActiveSection('about')}
        onMouseLeave={() => setActiveSection(null)}
      >
        <div className="section-header-ar">
          <span className="section-number-ar">٠١</span>
          <h2 className="section-title-ar">معلومات عني</h2>
        </div>
        <div className="about-content-ar">
          <div className="about-text-ar">
            <p>مطور تطبيقات ومواقع ويب متخصص، أمتلك خبرة في بناء حلول رقمية مبتكرة باستخدام أحدث التقنيات مثل React, Node.js, وأطر العمل الحديثة.</p>
            <p>أهتم بإنشاء تجارب مستخدم استثنائية وأحرص على كتابة كود نظيف وقابل للصيانة، مع التركيز على الأداء والأمان وقابلية التوسع.</p>
            <div className="about-details-ar">
              <div className="detail-item-ar">
                <span className="detail-label-ar">التخصص</span>
                <span className="detail-value-ar">تطبيقات ومواقع</span>
              </div>
              <div className="detail-item-ar">
                <span className="detail-label-ar">سنوات الخبرة</span>
                <span className="detail-value-ar">5+ سنوات</span>
              </div>
              <div className="detail-item-ar">
                <span className="detail-label-ar">المهارات</span>
                <span className="detail-value-ar">Full-Stack</span>
              </div>
            </div>
            <div className="about-more-ar">
              <Link to="/about" className="more-button-ar">عرض المزيد عني →</Link>
            </div>
          </div>
        </div>
      </section> */}

      {/* ===== قسم الخدمات ===== */}
      <section
        className={`services-section-ar ${activeSection === 'services' ? 'active' : ''}`}
        id="services"
        onMouseEnter={() => setActiveSection('services')}
        onMouseLeave={() => setActiveSection(null)}
      >
        <div className="portfolio-container-ar">
          <div className="section-header-ar">
            <span className="section-number-ar">٠1</span>
            <h2 className="section-title-ar">الخدمات التي أقدمها</h2>
          </div>
          <div className="services-timeline-ar">
            {services.map((service, index) => (
              <div
                className={`service-timeline-item-ar ${hoveredItem === `service-${service.id}` ? 'hovered' : ''}`}
                key={service.id}
                onMouseEnter={() => setHoveredItem(`service-${service.id}`)}
                onMouseLeave={() => setHoveredItem(null)}
              >
                <div className="timeline-content-ar">
                  <span className="timeline-date-ar">الخدمة {index + 1}</span>
                  <div className="service-icon-container-ar">
                    <div className="service-icon-ar">{service.icon}</div>
                  </div>
                  <h3 className="service-timeline-title-ar">{service.title}</h3>
                  <p className="service-timeline-desc-ar">{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== قسم المشاريع ===== */}
      <section
        className={`projects-section-ar ${activeSection === 'projects' ? 'active' : ''}`}
        onMouseEnter={() => setActiveSection('projects')}
        onMouseLeave={() => setActiveSection(null)}
      >
        <div className="section-header-ar">
          <span className="section-number-ar">٠2</span>
          <h2 className="section-title-ar">أحدث المشاريع</h2>
        </div>
        {loading ? (
          <div className="loading-ar">جاري تحميل المشاريع...</div>
        ) : error ? (
          <div className="error-ar">{error}</div>
        ) : (
          <>
            <div className="projects-grid-ar">
              {projects.slice(0, 2).map(project => (
                <div
                  className={`project-card-ar ${hoveredItem === project._id ? 'hovered' : ''}`}
                  key={project._id}
                  onMouseEnter={() => setHoveredItem(project._id)}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <div className="project-header-ar">
                    <span className="project-year-ar">{formatDate(project.meta?.startDate || project.system?.createdAt)}</span>
                    <div className="project-tags-ar">
                      {project.technical?.technologies?.map((tech, index) => (
                        <span key={index} className="project-tag-ar">{tech}</span>
                      ))}
                    </div>
                  </div>
                  <h3 className="project-title-ar">{project.details?.title}</h3>
                  <p className="project-description-ar">
                    {project.details?.description?.substring(0, 100)}
                    {project.details?.description?.length > 100 ? '...' : ''}
                  </p>
                  <div className="project-actions-ar">
                    <Link to={`/projects/${project._id}`} className="project-button-ar">عرض التفاصيل</Link>
                    {project.technical?.repositoryUrl && (
                      <a href={project.technical.repositoryUrl} className="project-button-ar secondary" target="_blank" rel="noopener noreferrer">الكود</a>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div className="projects-more-ar">
              <Link to="/projects" className="more-button-ar">عرض جميع المشاريع →</Link>
            </div>
          </>
        )}
      </section>

      {/* ===== قسم التواصل ===== */}
      <section className="contact-section-ar">
        <div className="contact-content-ar">
          <h2 className="contact-title-ar">لنصنع شيئاً مميزاً معاً</h2>
          <p className="contact-text-ar">مهتم بالتعاون أو لديك فكرة مشروع؟ أنا دائماً متاح لمناقشة الفرص الجديدة.</p>
          <div className="hero-actions-ar">
            <Link to="/books" className="secondary-button-ar">المكتبة</Link>
            <Link to="/blogs" className="secondary-button-ar">مدوناتي</Link>
            <Link to="/contact" className="primary-button-ar">تواصل معي</Link>
          </div>
        </div>
      </section>

    </div>
  );
};

export default PortfolioAR;